export default function APIURLs(snowType) {
    let snowURLs = {
        createUrl: '',
        updateUrl: '',
        getFieldsUrl: '',
        attachmentUrl: '',
        getUrl: ''

    };
    snowURLs = {
        getUrl: `/api/now/v2/table/${snowType}`,
        createUrl: `/api/now/v2/table/${snowType}`,
        updateUrl: `/api/now/v2/table/${snowType}/__sysId__`,
        getFieldsUrl: `/api/now/v2/table/sys_dictionary?sysparm_query=name%3D${snowType}%5EORname%3Dtask&sysparm_display_value=all&sysparm_fields=column_label,sys_name,name,read_only,max_length,active,mandatory,comments,sys_created_by,element,internal_type`,
        attachmentUrl: `/api/now/attachment/file?table_name=${snowType}&table_sys_id=__sysId__&file_name=__fileName__`
    };
    return snowURLs;
    
}
